<script>
export default {
    data() {
        return {
            swalTimer: undefined
        };
    },
    computed: {
        isBusy() {
            return !!this.swalTimer;
        }
    },
    methods: {
        dataIsLoading(show = true) {
            if (show) {
                this.$swal({
                    title: '資料載入中',
                    timer: 0,
                    timerProgressBar: true,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading()
                        this.swalTimer = setInterval(() => {
                            const content = this.$swal.getHtmlContainer();
                            if (content) {
                                const b = content.querySelector('b');
                                if (b) {
                                    b.textContent = this.$swal.getTimerLeft();
                                }
                            }
                        }, 100);
                    },
                    willClose: () => {
                        clearInterval(this.swalTimer);
                        this.swalTimer = undefined;
                    }
                });
            } else {
                this.$swal.close();
            }
        }
    }
}
</script>
